// extracted by mini-css-extract-plugin
module.exports = {"content__details":"styles_content__details__58vgO","content__details__cta":"styles_content__details__cta__5O4y4","content":"styles_content__YDzTk"};